import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CorporateStrip from "./components/CorporateStrip";
import ServicesPreview from "./components/ServicesPreview";
import BlogPreview from "./components/BlogPreview";
import ContactSection from "./components/ContactSection";

export default function HomePage() {
  return (
    <div className="min-h-screen flex flex-col font-body">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <CorporateStrip />
        <ServicesPreview />
        <BlogPreview />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}